// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"32862fe0","345":"2da30da5","453":"d855a71b"}[chunkId] + ".chunk.js";
};